import React from 'react';
import { motion } from 'framer-motion';
import { Book, Headphones } from 'lucide-react';
export function WhatYouGet() {
  return <section id="content" className="py-10 sm:py-16 lg:py-20 px-4 sm:px-6 lg:px-8 bg-zinc-900/30 border-y border-zinc-900" data-id="element-120">
      <div className="max-w-5xl mx-auto" data-id="element-121">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 sm:mb-12 lg:mb-16" data-id="element-122">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-2 sm:mb-4" data-id="element-123">
            Lo que vas a obtener con tu compra
          </h2>
          <p className="text-zinc-400 text-sm sm:text-base" data-id="element-124">
            Acceso inmediato a ambos formatos
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-4 sm:gap-6 lg:gap-8" data-id="element-125">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-[#0f0f0f] border border-zinc-800 p-5 sm:p-6 lg:p-8 rounded-xl hover:border-zinc-700 transition-colors" data-id="element-126">
            <div className="w-10 h-10 sm:w-12 sm:h-12 bg-zinc-800 rounded-lg flex items-center justify-center mb-4 sm:mb-6 text-white" data-id="element-127">
              <Book size={20} className="sm:w-6 sm:h-6" data-id="element-128" />
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-white mb-2 sm:mb-3" data-id="element-129">
              El eBook
            </h3>
            <p className="text-zinc-400 mb-3 sm:mb-4 text-xs sm:text-sm uppercase tracking-wider" data-id="element-130">
              Para leer a tu ritmo
            </p>
            <p className="text-zinc-300 text-sm sm:text-base" data-id="element-131">
              Ideal si quieres subrayar, tomar notas y volver a capítulos clave.
              Un documento histórico en tus manos.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-[#0f0f0f] border border-zinc-800 p-5 sm:p-6 lg:p-8 rounded-xl hover:border-zinc-700 transition-colors" data-id="element-132">
            <div className="w-10 h-10 sm:w-12 sm:h-12 bg-zinc-800 rounded-lg flex items-center justify-center mb-4 sm:mb-6 text-white" data-id="element-133">
              <Headphones size={20} className="sm:w-6 sm:h-6" data-id="element-134" />
            </div>
            <h3 className="text-lg sm:text-xl font-bold text-white mb-2 sm:mb-3" data-id="element-135">
              El AudioLibro
            </h3>
            <p className="text-zinc-400 mb-3 sm:mb-4 text-xs sm:text-sm uppercase tracking-wider" data-id="element-136">
              Para escucharlo donde sea
            </p>
            <ul className="text-zinc-300 space-y-2 text-sm sm:text-base" data-id="element-137">
              <li className="flex items-start gap-2" data-id="element-138">
                <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#FFCC00] flex-shrink-0" data-id="element-139"></span>
                <span data-id="element-140">Si manejas mucho o viajas</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-141">
                <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#00247D] flex-shrink-0" data-id="element-142"></span>
                <span data-id="element-143">Si trabajas y tienes poco tiempo libre</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-144">
                <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#CF142B] flex-shrink-0" data-id="element-145"></span>
                <span data-id="element-146">Si prefieres la emoción de la voz narrada</span>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}